function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(17.791 6.006)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 17.245,
  height: 2.243,
  transform: "translate(9.918 15.398) rotate(-125.106)",
  fill: "#59b4d9"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(27.768 20.222)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 17.665,
  height: 2.243,
  transform: "translate(8.776 16.446) rotate(-119.788)",
  fill: "#59b4d9"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.101 19.793)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 2.243,
  height: 21.451,
  transform: "translate(0.186 4.011) rotate(-94.747)",
  fill: "#59b4d9"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(20.153 20.366)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 2.243,
  height: 14.581,
  transform: "translate(1.921 13.646) rotate(-148.928)",
  fill: "#59b4d9"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(32.241)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-748.043,985H-759.4c-.421,0-.7.28-.7.841v4.066a.662.662,0,0,0,.7.7h6.449v6.309c0,.421.281.7.841.7h4.066a.662.662,0,0,0,.7-.7V985.7A.662.662,0,0,0-748.043,985Z",
  transform: "translate(760.1 -985)",
  fill: "#046eab"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 32.242)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-782.3,1020.518h11.356c.421,0,.7-.281.7-.841v-4.066a.662.662,0,0,0-.7-.7h-6.449V1008.6c0-.421-.281-.7-.841-.7H-782.3a.662.662,0,0,0-.7.7v11.216A.662.662,0,0,0-782.3,1020.518Z",
  transform: "translate(783 -1007.9)",
  fill: "#046eab"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(14.494 2.524)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 4.346,
  cy: 4.346,
  r: 4.346,
  fill: "#046eab"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(23.646 15.765)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 5.187,
  cy: 5.187,
  r: 5.187,
  fill: "#046eab"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(33.503 32.382)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 4.066,
  cy: 4.066,
  r: 4.066,
  fill: "#046eab"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(17.869 30.111)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3.505,
  cy: 3.505,
  r: 3.505,
  fill: "#046eab"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.645 19.418)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3.505,
  cy: 3.505,
  r: 3.505,
  fill: "#046eab"
})));

var SvgAzureIotHub = function SvgAzureIotHub(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44.86,
    viewBox: "0 0 45 44.86",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAzureIotHub, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/azure_iot_hub.5d1fbf20.svg";
export { ForwardRef as ReactComponent };